import AbstractTrigger from '@/ghost/service/Triggers/AbstractTrigger'
import { MethodDescriptor } from '@/common/model/PaymentMethod'

export default class DeclinePaymentTrigger extends AbstractTrigger {
  constructor($locator) {
    super($locator, 'declinePayment')
    this.browserRequests = $locator.browserRequests
  }

  async onEvent({ transactionUuid }) {
    try {
      const { response } = await this.callDeclinePayment(transactionUuid)
    } catch (error) {
      this.onError(error)
    }
  }

  async onError(error, path = 'ghost/service/DeclinePaymentTrigger.onEvent') {
    super.onError(error, path)
  }

  async callDeclinePayment(transactionUuid) {
    await super.onEvent({})

    const { formToken, publicKey } = this.$store.state
    let url = this.restAPI.getDeclinePaymentUrl(this.endpoint)
    url = this.restAPI.addJSessionID(url)
    const requestData = this.storeFactory.create('requestData', {
      url,
      objectData: {
        formToken,
        publicKey,
        wsUser: this.restAPI.getWSUser(),
        transactionUuid
      },
      headers: {},
      options: {}
    })
    const { response } = await this.browserRequests.post(requestData)
    if (response.status === 'ERROR')
      throw { metadata: { answer: response.answer } }

    return response
  }
}
